import { Component, TemplateRef, ViewChild, ElementRef, OnDestroy }          from '@angular/core';
import { Router, ActivatedRoute, Params }                   from '@angular/router';
import { FormGroup, FormControl,
  FormBuilder, Validators }   from '@angular/forms'
import { NotificationsService }     from 'angular2-notifications';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation, NgxGalleryImageSize } from 'ngx-gallery';

import { Subject }            from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {distinctUntilChanged} from 'rxjs/operators';

import {I18NService} from "../../../shared/i18n/i18n.service";
import {Notification} from "../../../model/notification";
import {IPlaceValuelistService} from "../../../iPlace/iPlace-valuelist.service";
import {TagService} from "../../tag/Tag.service";
import {ItemTagType} from "../../tag/Tag";
import {Globals} from "../../../globals";
import {IncidenceService} from "./incidence.service";
import {SergasDeviceValuelistService} from "../device/SergasDeviceValuelist.service";


@Component({
  templateUrl: './IncidenceList.component.html',
  styleUrls: [ './IncidenceList.component.css'],
})
export class IncidenceListComponent implements OnDestroy{

  rows: any[] = [];
  incidence;
  private searchText= '';
  private searchTerms = new Subject<string>();
  isLoading = false;
  tableMessages: any;
  incidencePage: any;
  sort = 'initDate,desc';
  sorts = [{prop: 'initDate', dir: 'desc'}];

  modalRef: BsModalRef;

  search: string;
  @ViewChild('detailTemplate', { static: true })
  private detailTempRef : TemplateRef<any>;
  private filter: string;

  dropdownList:any = [];
  selectedItems:any = [];
  itemTags: any[] = [];
  iPlaceList:any[] = [];
  iPlaceMap:any[];
  dropdownSettings:any = {};
  tagDropdownSettings:any = {};
  dateRangeFilter:any;
  bsConfig: Partial<BsDatepickerConfig>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private i18nService: I18NService,
    private modalService: BsModalService,
    private displayNotificationService: NotificationsService,
    private localeService: BsLocaleService,
    private tagService: TagService,
    private iPlaceValuelistService: IPlaceValuelistService,
    private sergasDeviceValuelistService: SergasDeviceValuelistService,
    private incidenceService: IncidenceService,
    private globals: Globals) {

    this.incidencePage = {
      count: 0,
      pageSize: 15,
      offset: 0,
    };

    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((result) => {
        this.searchText = result.toUpperCase();
        this.incidencePage.pageSize = 15;
        this.incidencePage.offset = 0;
        this.setIncidencePage(this.incidencePage);
      });

    this.route.params.subscribe((params: Params) => {
      if (params["filter"]) {
        this.searchText = params["filter"].toUpperCase();
        this.search = params["filter"];
      }
    });

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");

    this.sergasDeviceValuelistService.reload().then(valueList =>{

    });

    if ( (<any>Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
        previous[current.id] = current;
        return previous;
      }, {});
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => {
          this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
            .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
            previous[current.id] = current;
            return previous;
          }, {});
          if ( globals.tenant == "ecomanager" ) {
            this.setGroupedIPlaceList()
          } else {
            this.dropdownList = this.iPlaceList;
          }
        })
    }

    let iPlaceSelectorText = i18nService.get("selectiPlaces");
    let groupBy = null;
    if ( globals.tenant == "ecomanager" ) {
      iPlaceSelectorText =i18nService.get("selectStation");
      groupBy = "tag";
      this.tagService.getItemTags(ItemTagType.IPLACE)
        .then( itemTags => {
          this.itemTags = itemTags;
          this.setGroupedIPlaceList()
        });
    } else {
      this.dropdownList = this.iPlaceList;
    }

    this.dropdownSettings = {
      singleSelection: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: iPlaceSelectorText,
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: groupBy,
      classes: "form-angular2-multiselect"
    };

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});

    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    let endDate = new Date();
    endDate.setHours(0,0,0,0);
    endDate = new Date(endDate.getTime() - 604800000);
    this.dateRangeFilter = [endDate, startDate];

    this.setIncidencePage(this.incidencePage);
  }

  private setGroupedIPlaceList(){
    if ( this.iPlaceMap ) {
      this.itemTags.forEach(itemTag => {
        let iplace = this.iPlaceMap[itemTag.id.itemId];
        if ( iplace && !iplace.tag ) {
          iplace.tag = itemTag.id.tagKey;
        }
      });

    }

    if ( this.iPlaceList.length ) {
      if ( !this.itemTags || !this.itemTags.length ) {
        this.dropdownSettings.groupBy = false;
      }
    }

    this.dropdownList = this.iPlaceList.sort((a:any,b:any) => {
      if ( !a.tag ) {
        return -1
      } else if (a.tag == b.tag) {
        return a.iPlaceName.localeCompare(b.iPlaceName);
      } else {
        return a.tag.localeCompare(b.tag);
      }
    });
  }

  clearFilters(){
    this.selectedItems = null;
    this.dateRangeFilter = null;
    this.incidencePage.pageSize = 15;
    this.incidencePage.offset = 0;
    this.setIncidencePage(this.incidencePage);
  }

  onItemSelect(item: any) {
    this.incidencePage.pageSize = 15;
    this.incidencePage.offset = 0;
    this.setIncidencePage(this.incidencePage);
  }
  onSelectAll(items: any) {
    this.incidencePage.pageSize = 15;
    this.incidencePage.offset = 0;
    this.setIncidencePage(this.incidencePage);
  }

  onDateRangeChange(any:any){
    this.incidencePage.pageSize = 15;
    this.incidencePage.offset = 0;
    this.setIncidencePage(this.incidencePage);

  }
  onSearch(term: string){
    this.searchTerms.next(term);
  }

  setIncidencePage(pageInfo:any){
    this.isLoading = true;
    this.incidencePage.offset = pageInfo.offset;
    let filter = "";
    if ( this.searchText ) {
      let or = filter ? ";" : "";
      filter += this.searchText ? or + "|sergasDevice.deviceName:ilike:" + this.searchText : "";
    }
    // if ( this.selectedItems && this.selectedItems.length ) {
    //   let or = filter ? ";" : "";
    //   filter +=  or + "idiPlace:in:" + this.selectedItems.map(e => e.idiPlace).join(",");
    // }
    if ( this.dateRangeFilter && this.dateRangeFilter.length == 2 ) {
      let or = filter ? ";" : "";
      filter +=  or + "startDate:=:" + this.dateRangeFilter[0].getTime() + ":T;endDate:=:" + (this.dateRangeFilter[1].getTime() + 86400000)+ ":T";
    }

    this.incidenceService.getPage(pageInfo.offset,pageInfo.pageSize -1,this.sort, filter)
      .then( response => {
        this.isLoading = false;
        let sort = response.sort ? response.sort[0].property + "," + response.sort[0].direction : "";
        this.incidencePage = {
          count: response.totalElements,
          pageSize: response.size,
          offset: response.number
        };
        this.rows = response.content;
        this.sorts = [{prop: response.sort[0].property, dir: response.sort[0].direction.toLowerCase()}];
      })
      .catch( error => {
        this.isLoading = false;
      });
  }

  onSort(event:any) {
    let prop = event.sorts[0].prop == "idiPlace" ? "iPlace.iPlaceName" : event.sorts[0].prop;
    this.sort = prop + "," + event.sorts[0].dir;
    this.setIncidencePage(this.incidencePage);
  }

  onActivate(event: any) {
    if ( event.type == 'click' && event.column.prop) {
      this.incidence = event.row;

      // this.modalRef = this.modalService.show(this.detailTempRef);
      // let promise = this.loadNotification(event.row.id);
      // promise.catch( (error:any) => {
      //   this.modalService.hide(1);
      // });
    }
  }

  goToDetail(row) {
    this.router.navigate(['cloud/incidences/' + row.incidenceId ]);
  }

  createIcidence(){
    this.router.navigate(['cloud/incidences/new' ]);
  }

  public ngOnDestroy(): void {
  }

}
